import Vue from 'vue'
import Router from 'vue-router'
import WapIndex from '@/views/wap/index.vue'
import WebIndex from '@/views/web/index.vue'
// import memberCenter from './member_center'
Vue.use(Router)
var router = new Router({
  // mode: 'history',
  // mode: 'hsas',
  base: './',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/wap',
      name: 'wap',
      component: WapIndex
    },
    {
      path: '/web',
      name: 'web',
      component: WebIndex
    },
    {
      path: '/column',
      name: 'column',
      component: () => import(/* webpackChunkName: "about" */ '@/views/web/column.vue')
    },
    {
      path: '/music',
      name: 'music',
      component: () => import(/* webpackChunkName: "about" */ '@/views/web/music.vue')
    },
    {
      path: '/memberCenter',
      name: 'memberCenter',
      component: () => import('@/views/web/memberCenter.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ '@/views/home.vue'),
      redirect: '/home/firstpage',
      children: [
        {
          path: '/home/firstpage',
          name: 'firstpage',
          component: () => import(/* webpackChunkName: "about" */ '@/views/pages/firstpage.vue'),
          meta: {
            title: '321视频-首页'
          }
        },
        {
          path: '/home/publicpage',
          name: 'publicpage',
          component: () => import(/* webpackChunkName: "about" */ '@/views/pages/publicpage.vue'),
          meta: {
            title: '321视频-321广场舞'
          }
        },
        {
          path: '/home/alldance',
          name: 'alldance',
          component: () => import(/* webpackChunkName: "about" */ '@/views/pages/alldance.vue'),
          meta: {
            title: '321视频-舞蹈教学'
          }
        },
        {
          path: '/home/activepage',
          name: 'activepage',
          component: () => import(/* webpackChunkName: "about" */ '@/views/pages/activepage.vue'),
          meta: {
            title: '321视频-资讯活动'
          }
        },
        {
          path: '/home/musicpage',
          name: 'musicpage',
          component: () => import(/* webpackChunkName: "about" */ '@/views/pages/musicpage.vue'),
          meta: {
            title: '321视频-精选音乐'
          }
        },
        {
          path: '/home/memberpage',
          name: 'memberpage',
          component: () => import(/* webpackChunkName: "about" */ '@/views/pages/memberpage.vue'),
          meta: {
            title: '321视频-会员中心'
          }
        },
        {
          path: '/home/aboutpage',
          name: 'aboutpage',
          component: () => import(/* webpackChunkName: "about" */ '@/views/pages/aboutpage.vue'),
          meta: {
            title: '321视频-关于我们'
          }
        },
        {
          path: '/home/videodetail',
          name: 'videodetail',
          component: () => import(/* webpackChunkName: "about" */ '@/views/pages/videodetail.vue'),
          meta: {
            title: '321视频-详情'
          }
        },
        {
          path: '/home/videoManagement',
          name: 'videoManagement',
          component: () => import(/* webpackChunkName: "about" */ '@/views/pages/videoManagement.vue'),
          meta: {
            title: '321视频-发布视频'
          }
        },
        {
          path: '/home/addvideo',
          name: 'addvideo',
          component: () => import(/* webpackChunkName: "about" */ '@/views/pages/addVideo.vue'),
          meta: {
            title: '321视频-发布视频'
          }
        },
        {
          path: '/home/searchpage',
          name: 'searchpage',
          component: () => import(/* webpackChunkName: "about" */ '@/views/pages/searchpage.vue'),
          meta: {
            title: '321视频-搜索页'
          }
        }
      ]
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: () => import(/* webpackChunkName: "about" */ '@/views/alltext/agreement.vue'),
      meta: {
        title: '321视频-用户服务协议'
      }
    },
    {
      path: '/complaint',
      name: 'complaint',
      component: () => import(/* webpackChunkName: "about" */ '@/views/alltext/complaint.vue'),
      meta: {
        title: '321视频-侵权投诉'
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import(/* webpackChunkName: "about" */ '@/views/alltext/privacy.vue'),
      meta: {
        title: '321视频-隐私政策'
      }
    },
    {
      path: '/cancellaction',
      name: 'cancellaction',
      component: () => import(/* webpackChunkName: "about" */ '@/views/alltext/cancellaction.vue'),
      meta: {
        title: '321视频-注销须知'
      }
    },
  ]
})

export default router
